import { createReducer, on } from '@ngrx/store';
import {
	setFulfillmentButtonsShipMode,
	setNearbyStoresButtonEnabledFlag
} from './fulfillment-buttons.actions';
import { FulfillmentState } from '@pdp/data-access/interfaces';

const initialFulfillmentButtonsState: FulfillmentState['fulfillmentButtonsReducer'] = {
	shipMode: 'shipToMe'
};


export const fulfillmentButtonsReducer = createReducer(
	initialFulfillmentButtonsState,
	on(setFulfillmentButtonsShipMode, (state, action) => ({
			...state,
			shipMode: action.shipMode
	})),
	on(setNearbyStoresButtonEnabledFlag, (state, { nearbyStoresButtonEnabled }) => ({
		...state,
		nearbyStoresButtonEnabled: nearbyStoresButtonEnabled
	}))
);
